module.exports = __webpack_public_path__ + "media/icons/outside-link-f4f6818f.png";